import Phaser from "phaser";
import coinShowBg from "@assets/imgs/shop/coin-show-bg.png";
import coinIcon from "@assets/imgs/icons/coin-icon.png";

export class CoinShowPanel extends Phaser.GameObjects.Container {
  private bg: Phaser.GameObjects.Image;
  private text: Phaser.GameObjects.Text;
  private icon: Phaser.GameObjects.Image;

  static preload(scene: Phaser.Scene) {
    scene.load.image("coin-show-bg", coinShowBg);
    scene.load.image("coin-icon", coinIcon);
  }

  constructor(scene: Phaser.Scene, x: number, y: number) {
    super(scene, x, y);
    scene.add.existing(this);

    this.bg = scene.add.image(0, 0, "coin-show-bg").setOrigin(0.5);

    const BG_WIDTH = 212;

    this.icon = scene.add
      .image(-BG_WIDTH / 2 + 16, 0, "coin-icon")
      .setScale(0.24)
      .setOrigin(0.5);

    this.text = scene.add
      .text(BG_WIDTH / 2, -2, "0", {
        fontFamily: "Black Han Sans",
        fontSize: "30px",
        color: "#ffffff",
      })
      .setOrigin(1, 0.5);

    this.add([this.bg, this.icon, this.text]);
  }

  setCoins(amount: number) {
    this.text.setText(amount.toLocaleString());
  }
}
